import { inject, Injectable } from '@angular/core';

import { NotificationsService } from 'app/services/notifications';

@Injectable()
export class ClipboardService {
    private notificationsService = inject(NotificationsService);

    copyToClipboard(text: string) {
        if (typeof document.execCommand !== 'function') {
            this.copyError();
            return;
        }
        const element = document.createElement('input');
        element.id = 'clipboard-element';
        element.value = text;

        const body = document.getElementsByTagName('body')[0];
        body.appendChild(element);

        (document.getElementById('clipboard-element') as HTMLInputElement).select();
        document.execCommand('copy');
        document.body.removeChild(element);

        this.copySuccess();
    }

    private copySuccess() {
        this.notificationsService.translateSuccess('global.copy_success');
    }

    private copyError() {
        this.notificationsService.translateError('global.copy_error');
    }
}
